import { DialerApiError, type DialerApi } from "./api/types";

const fail = async (): Promise<never> => {
  throw new DialerApiError("dialer_unavailable");
};

/** Production placeholder until Task I1 ships the Supabase RPC DialerApi: reads are empty, writes fail. */
export const unavailableDialerApi = (): DialerApi => ({
  getActiveSession: async () => null,
  startSession: fail,
  endSession: fail,
  pauseSession: fail,
  claimNext: fail,
  claimSpecific: fail,
  renewLease: fail,
  releaseLease: fail,
  markCallLaunched: fail,
  logOutcome: fail,
  logOffCrmCall: fail, // GAVION off-CRM call
  skipCallback: fail, // GAVION skip-callback
  queuePreview: async () => [],
  queueFilterOptions: async () => [],
  callbacksLaterToday: async () => [], // GAVION callbacks today
  todayStats: async () => ({ dials: 0, contacts: 0, demos: 0 }),
  todoCalls: async () => [],
  callHistory: async () => ({ rows: [], total: 0 }), // GAVION my-calls
  recentActivity: async () => [],
  deleteDeal: fail,
  getMyPrefs: async () => ({}),
  saveMyPrefs: fail,
  setMyDigestEnabled: fail,
  setMyMissedCallEmail: fail, // GAVION rep-missed-call
  startInboundCall: fail, // GAVION inbound calls
  endInboundCall: fail, // GAVION inbound calls
});
